import CloseIcon from "@uui/XClose";

import Typography from "@mui/material/Typography";

import Modal from "@app/analytics/components/Modal";

import Button from "@rui/Button";
import IconButton from "@rui/IconButton";
import ModalTitle from "@rui/Modal/ModalTitle";
import { Column, Row } from "@rui/Stack";

import EditableSettings from "./EditableSettings";
import SETTINGS from "./settings";
import { ModalContent } from "./styles";

const AdvancedSettingsModal = ({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{ width: "600px", height: "638px" }}
    >
      <Column height="100%" overflow="hidden" justifyContent="space-between">
        <Row variant="apart" paddingX={3} paddingY={2}>
          <Column spacing={0.5}>
            <ModalTitle>Advanced Settings</ModalTitle>
            <Typography variant="labelReg" color="shades.neutral.600">
              Recommended settings are preset to save you time
            </Typography>
          </Column>
          <IconButton variant="outlined" size="small" onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Row>
        <ModalContent flex={1}>
          <EditableSettings settings={SETTINGS} />
        </ModalContent>
        <Row variant="right" paddingX={3} paddingY={2}>
          <Button onClick={onClose}>Done</Button>
        </Row>
      </Column>
    </Modal>
  );
};

export default AdvancedSettingsModal;
